/**
 * Info Tooltip Component
 * ======================
 * Re-export HelpTooltip for backwards compatibility
 */

import HelpTooltip from './HelpTooltip';

export default HelpTooltip;
export { HelpTooltip };
export const InfoTooltip = HelpTooltip;

